<template>
  <Btn :label="$t('ELE0125')" icon="mdi-replay" @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnReset',

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Btn,
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
